// extracted by mini-css-extract-plugin
export default {"eyeHover":"styles_eyeHover__dAXlk","starHover":"styles_starHover__R-DSX","starHoverActive":"styles_starHoverActive__KRBD2"};